import { Button, ButtonProps } from '@cmpsr/components';

export default function ContinueButton(props: ButtonProps) {
  return (
    <Button type="submit" size="l" variant="primary" {...props}>
      Continue
    </Button>
  );
}
